import React from "react";

export const Upload = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-upload-line" clipPath="url(#clip0_1168_6022)">
      <g id="Group">
        <path
          id="Vector"
          d="M2.5 15.8337H17.5V17.5003H2.5V15.8337ZM10.8333 4.85699V14.167H9.16667V4.85699L4.1075 9.91699L2.92917 8.73866L10 1.66699L17.0708 8.73782L15.8925 9.91616L10.8333 4.85866V4.85699Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1168_6022">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Search = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Search"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7688 10.4311C11.7033 10.3656 11.3918 10.6865 11.3264 10.621C11.2444 10.539 11.3264 9.98853 11.3264 9.98853C12.1116 8.91751 12.5323 7.62267 12.5264 6.29463C12.5114 2.82801 9.70757 0.0200628 6.24098 4.04042e-05C4.58202 -0.00746544 2.98896 0.648822 1.81669 1.8227C0.644426 2.99658 -0.00967467 4.59054 0.000108177 6.24949C0.0150914 9.71642 2.81922 12.5246 6.28613 12.5447C7.61958 12.5504 8.91914 12.1249 9.99088 11.3314L9.99545 11.328C9.99545 11.328 10.5012 11.2493 10.5799 11.328C10.6388 11.387 10.352 11.6847 10.4156 11.7484C11.8425 13.1761 14.3722 15.7071 14.3722 15.7071C14.6089 15.9553 14.9615 16.0558 15.2934 15.9696C15.6254 15.8834 15.8845 15.624 15.9705 15.292C16.0564 14.96 15.9556 14.6075 15.7072 14.371C15.7072 14.371 13.0816 11.7444 11.7688 10.4311ZM6.28165 11.2898C3.50828 11.2738 1.26501 9.02748 1.25284 6.25408C1.24535 4.92709 1.76867 3.65218 2.70631 2.71315C3.64395 1.77412 4.91808 1.2489 6.24508 1.25441C9.01846 1.27036 11.2617 3.51669 11.2739 6.29008C11.2814 7.61707 10.7581 8.89198 9.82042 9.83101C8.88278 10.77 7.60865 11.2953 6.28165 11.2898Z"
      fill="#757D8A"
    />
  </svg>
);

export const SearchDark = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7688 11.4311C12.7033 11.3656 12.3918 11.6865 12.3264 11.621C12.2444 11.539 12.3264 10.9886 12.3264 10.9886C13.1116 9.91753 13.5323 8.62269 13.5264 7.29466C13.5114 3.82804 10.7076 1.02009 7.24098 1.00006C5.58202 0.992558 3.98896 1.64885 2.81669 2.82272C1.64443 3.9966 0.990325 5.59056 1.00011 7.24951C1.01509 10.7164 3.81922 13.5247 7.28613 13.5447C8.61958 13.5505 9.91914 13.1249 10.9909 12.3315L10.9955 12.328C10.9955 12.328 11.5012 12.2493 11.5799 12.328C11.6388 12.387 11.352 12.6847 11.4156 12.7484C12.8425 14.1761 15.3722 16.7071 15.3722 16.7071C15.6089 16.9554 15.9615 17.0559 16.2934 16.9696C16.6254 16.8834 16.8845 16.6241 16.9705 16.292C17.0564 15.96 16.9556 15.6075 16.7072 15.371C16.7072 15.371 14.0816 12.7444 12.7688 11.4311ZM7.28165 12.2898C4.50828 12.2738 2.26501 10.0275 2.25284 7.2541C2.24535 5.92712 2.76867 4.65221 3.70631 3.71317C4.64395 2.77414 5.91808 2.24892 7.24508 2.25443C10.0185 2.27039 12.2617 4.51671 12.2739 7.29011C12.2814 8.61709 11.7581 9.892 10.8204 10.831C9.88278 11.7701 8.60865 12.2953 7.28165 12.2898Z"
      fill="#121212"
    />
    <path
      d="M12.7688 11.4311L12.5919 11.6078L12.7688 11.4311ZM12.3264 11.621L12.1496 11.7978L12.3264 11.621ZM12.3264 10.9886L12.1248 10.8407L12.0882 10.8906L12.0791 10.9517L12.3264 10.9886ZM13.5264 7.29466L13.2764 7.29574V7.29576L13.5264 7.29466ZM7.24098 1.00006L7.24243 0.750068L7.24211 0.750066L7.24098 1.00006ZM1.00011 7.24951L1.25011 7.24843L1.2501 7.24804L1.00011 7.24951ZM7.28613 13.5447L7.28468 13.7947L7.28504 13.7947L7.28613 13.5447ZM10.9909 12.3315L11.1396 12.5324L11.1409 12.5315L10.9909 12.3315ZM10.9955 12.328L10.957 12.081L10.8953 12.0906L10.8454 12.128L10.9955 12.328ZM11.5799 12.328L11.7567 12.1513L11.5799 12.328ZM11.4156 12.7484L11.5924 12.5717L11.4156 12.7484ZM15.3722 16.7071L15.5532 16.5346L15.5491 16.5304L15.3722 16.7071ZM16.7072 15.371L16.5303 15.5478L16.5348 15.5522L16.7072 15.371ZM7.28165 12.2898L7.28021 12.5398L7.28061 12.5398L7.28165 12.2898ZM2.25284 7.2541L2.50283 7.25301L2.50283 7.25269L2.25284 7.2541ZM7.24508 2.25443L7.24652 2.00444L7.24612 2.00443L7.24508 2.25443ZM12.2739 7.29011L12.0239 7.2912L12.0239 7.29152L12.2739 7.29011ZM12.9456 11.2544C12.8564 11.1651 12.7467 11.1679 12.6942 11.1763C12.6414 11.1847 12.5964 11.2052 12.5688 11.2191C12.5117 11.2478 12.4497 11.2904 12.4073 11.3191C12.3555 11.3542 12.3233 11.3755 12.3015 11.3865C12.2897 11.3924 12.2991 11.3858 12.3221 11.3821C12.3447 11.3785 12.4303 11.3714 12.5032 11.4443L12.1496 11.7978C12.2388 11.887 12.3485 11.8842 12.4009 11.8759C12.4537 11.8674 12.4987 11.847 12.5263 11.8331C12.5834 11.8043 12.6454 11.7618 12.6878 11.733C12.7396 11.6979 12.7718 11.6766 12.7936 11.6657C12.8054 11.6597 12.7961 11.6664 12.773 11.67C12.7504 11.6736 12.6648 11.6807 12.5919 11.6078L12.9456 11.2544ZM12.5032 11.4443C12.5427 11.4838 12.5483 11.5217 12.5457 11.5109C12.545 11.5082 12.5428 11.4964 12.5413 11.4724C12.5384 11.4252 12.5402 11.3612 12.545 11.2913C12.5498 11.223 12.5569 11.1562 12.563 11.1059C12.5661 11.0809 12.5688 11.0604 12.5707 11.0463C12.5717 11.0392 12.5724 11.0338 12.5729 11.0302C12.5732 11.0284 12.5734 11.0271 12.5735 11.0263C12.5736 11.0259 12.5736 11.0256 12.5736 11.0255C12.5736 11.0254 12.5737 11.0253 12.5737 11.0253C12.5737 11.0253 12.5737 11.0253 12.5737 11.0253C12.5737 11.0253 12.5736 11.0253 12.5736 11.0253C12.5736 11.0254 12.5736 11.0254 12.3264 10.9886C12.0791 10.9517 12.0791 10.9517 12.0791 10.9518C12.0791 10.9518 12.0791 10.9518 12.0791 10.9518C12.0791 10.9519 12.0791 10.9519 12.0791 10.952C12.079 10.9521 12.079 10.9523 12.079 10.9524C12.0789 10.9528 12.0789 10.9533 12.0788 10.954C12.0786 10.9552 12.0783 10.957 12.078 10.9593C12.0773 10.9638 12.0764 10.9703 12.0753 10.9785C12.0731 10.9948 12.07 11.0179 12.0667 11.0458C12.0599 11.1013 12.0517 11.1771 12.0462 11.2567C12.0408 11.3347 12.0374 11.4237 12.0422 11.5028C12.0446 11.5419 12.0494 11.5866 12.06 11.6297C12.0686 11.6647 12.0896 11.7378 12.1496 11.7978L12.5032 11.4443ZM12.528 11.1364C13.3449 10.0222 13.7825 8.67513 13.7764 7.29355L13.2764 7.29576C13.2821 8.57026 12.8784 9.81289 12.1248 10.8407L12.528 11.1364ZM13.7764 7.29358C13.7609 3.68987 10.8461 0.770882 7.24243 0.750068L7.23954 1.25006C10.569 1.26929 13.262 3.9662 13.2764 7.29574L13.7764 7.29358ZM7.24211 0.750066C5.5164 0.742258 3.85924 1.42495 2.6398 2.64607L2.99359 2.99938C4.11869 1.87274 5.64765 1.24286 7.23985 1.25006L7.24211 0.750066ZM2.6398 2.64607C1.42036 3.86718 0.739936 5.52528 0.750113 7.25099L1.2501 7.24804C1.24071 5.65584 1.86849 4.12602 2.99359 2.99938L2.6398 2.64607ZM0.750111 7.25059C0.765686 10.8546 3.68069 13.7739 7.28468 13.7947L7.28757 13.2947C3.95775 13.2754 1.2645 10.5783 1.25011 7.24843L0.750111 7.25059ZM7.28504 13.7947C8.67242 13.8007 10.0245 13.3579 11.1396 12.5324L10.8421 12.1305C9.81374 12.8919 8.56673 13.3002 7.28721 13.2947L7.28504 13.7947ZM11.1409 12.5315L11.1455 12.528L10.8454 12.128L10.8409 12.1315L11.1409 12.5315ZM10.9955 12.328C11.0339 12.5751 11.0339 12.5751 11.0339 12.5751C11.0339 12.5751 11.0339 12.5751 11.0339 12.5751C11.0338 12.5751 11.0338 12.5751 11.0338 12.5751C11.0338 12.5751 11.0339 12.5751 11.0339 12.5751C11.0341 12.575 11.0343 12.575 11.0347 12.575C11.0354 12.5748 11.0366 12.5747 11.0382 12.5744C11.0414 12.5739 11.0463 12.5732 11.0527 12.5723C11.0656 12.5705 11.0843 12.5679 11.1071 12.565C11.153 12.5592 11.2139 12.5524 11.2762 12.5479C11.34 12.5433 11.3977 12.5417 11.4396 12.5443C11.4495 12.545 11.4572 12.5457 11.463 12.5465C11.469 12.5473 11.4715 12.548 11.4711 12.5479C11.4708 12.5478 11.4692 12.5474 11.4666 12.5465C11.4641 12.5456 11.4599 12.5441 11.4545 12.5416C11.445 12.5371 11.4246 12.5264 11.403 12.5048L11.7567 12.1513C11.6983 12.0929 11.628 12.0718 11.5932 12.063C11.5512 12.0524 11.5083 12.0477 11.4711 12.0453C11.3961 12.0406 11.3125 12.0439 11.2401 12.0492C11.1661 12.0545 11.0957 12.0625 11.0443 12.0689C11.0185 12.0722 10.9971 12.0752 10.9819 12.0773C10.9744 12.0784 10.9684 12.0793 10.9641 12.0799C10.962 12.0803 10.9603 12.0805 10.9591 12.0807C10.9585 12.0808 10.9581 12.0809 10.9577 12.0809C10.9575 12.0809 10.9574 12.081 10.9573 12.081C10.9572 12.081 10.9571 12.081 10.9571 12.081C10.9571 12.081 10.957 12.081 10.957 12.081C10.957 12.081 10.957 12.081 10.9955 12.328ZM11.403 12.5048C11.3287 12.4304 11.3369 12.3432 11.3399 12.3235C11.3432 12.3011 11.3494 12.2916 11.3441 12.3027C11.3344 12.3232 11.3158 12.3533 11.2843 12.4035C11.2587 12.4442 11.2203 12.5048 11.1948 12.5615C11.1823 12.5892 11.1644 12.6339 11.1584 12.6862C11.1524 12.7388 11.155 12.8414 11.2388 12.9252L11.5924 12.5717C11.6603 12.6396 11.6579 12.7189 11.6552 12.7428C11.6525 12.7664 11.6461 12.777 11.6507 12.7668C11.6592 12.7479 11.6769 12.7185 11.7077 12.6695C11.7325 12.6299 11.7706 12.5705 11.7961 12.5166C11.8084 12.4905 11.8269 12.4476 11.8344 12.3974C11.8415 12.3498 11.8458 12.2404 11.7567 12.1513L11.403 12.5048ZM11.2388 12.9252C11.9522 13.639 12.9414 14.6287 13.7522 15.4399C14.1576 15.8455 14.5184 16.2065 14.7778 16.4661C14.9076 16.5959 15.012 16.7003 15.0839 16.7723C15.1199 16.8083 15.1478 16.8362 15.1667 16.8551C15.1761 16.8645 15.1833 16.8717 15.1881 16.8765C15.1906 16.879 15.1923 16.8807 15.1936 16.882C15.1942 16.8826 15.1946 16.883 15.1949 16.8834C15.1951 16.8835 15.1952 16.8836 15.1953 16.8837C15.1953 16.8838 15.1954 16.8838 15.1954 16.8838C15.1954 16.8838 15.1954 16.8838 15.3722 16.7071C15.5491 16.5304 15.549 16.5304 15.549 16.5304C15.549 16.5303 15.549 16.5303 15.5489 16.5303C15.5489 16.5303 15.5487 16.53 15.5486 16.5299C15.5483 16.5296 15.5478 16.5291 15.5472 16.5285C15.546 16.5273 15.5442 16.5255 15.5418 16.5231C15.5369 16.5182 15.5297 16.5111 15.5203 16.5016C15.5014 16.4827 15.4736 16.4548 15.4376 16.4188C15.3656 16.3468 15.2612 16.2424 15.1315 16.1126C14.872 15.853 14.5112 15.492 14.1058 15.0864C13.295 14.2752 12.3059 13.2855 11.5924 12.5717L11.2388 12.9252ZM15.1913 16.8796C15.4905 17.1936 15.9365 17.3206 16.3563 17.2116L16.2306 16.7277C15.9865 16.7911 15.7272 16.7172 15.5532 16.5346L15.1913 16.8796ZM16.3563 17.2116C16.7761 17.1026 17.1038 16.7746 17.2125 16.3547L16.7284 16.2294C16.6653 16.4735 16.4747 16.6643 16.2306 16.7277L16.3563 17.2116ZM17.2125 16.3547C17.3212 15.9348 17.1937 15.4889 16.8795 15.1899L16.5348 15.5522C16.7175 15.726 16.7916 15.9852 16.7284 16.2294L17.2125 16.3547ZM16.7072 15.371C16.884 15.1943 16.884 15.1943 16.8839 15.1943C16.8839 15.1943 16.8839 15.1942 16.8838 15.1942C16.8832 15.1936 16.8842 15.1945 16.8835 15.1938C16.8831 15.1935 16.8827 15.1931 16.8821 15.1924C16.8808 15.1912 16.8789 15.1892 16.8764 15.1867C16.8714 15.1817 16.8639 15.1742 16.8542 15.1645C16.8346 15.1449 16.8058 15.1161 16.7686 15.0789C16.6942 15.0045 16.5865 14.8968 16.4532 14.7634C16.1865 14.4966 15.8173 14.1272 15.4071 13.7168C14.5866 12.896 13.602 11.911 12.9456 11.2544L12.5919 11.6078C13.2483 12.2645 14.2329 13.2495 15.0534 14.0703C15.4637 14.4807 15.8329 14.8501 16.0996 15.1169C16.2329 15.2502 16.3406 15.358 16.415 15.4324C16.4521 15.4696 16.481 15.4984 16.5005 15.518C16.5103 15.5278 16.5178 15.5352 16.5228 15.5402C16.5253 15.5427 16.5272 15.5446 16.5284 15.5459C16.529 15.5465 16.5296 15.547 16.5299 15.5473C16.5299 15.5474 16.53 15.5475 16.5301 15.5475C16.5301 15.5476 16.5302 15.5476 16.5302 15.5477C16.5303 15.5477 16.5303 15.5477 16.5303 15.5478C16.5303 15.5478 16.5303 15.5478 16.7072 15.371ZM7.28309 12.0398C4.64679 12.0246 2.51441 9.88932 2.50283 7.25301L2.00284 7.2552C2.01562 10.1657 4.36976 12.523 7.28021 12.5398L7.28309 12.0398ZM2.50283 7.25269C2.49572 5.99243 2.99273 4.78163 3.88322 3.88982L3.52941 3.53653C2.54462 4.52278 1.99498 5.8618 2.00284 7.25551L2.50283 7.25269ZM3.88322 3.88982C4.77371 2.998 5.98377 2.49919 7.24404 2.50443L7.24612 2.00443C5.85239 1.99864 4.51419 2.55027 3.52941 3.53653L3.88322 3.88982ZM7.24364 2.50443C9.87994 2.51959 12.0123 4.65489 12.0239 7.2912L12.5239 7.28901C12.5111 4.37853 10.157 2.02118 7.24652 2.00444L7.24364 2.50443ZM12.0239 7.29152C12.031 8.55177 11.534 9.76258 10.6435 10.6544L10.9973 11.0077C11.9821 10.0214 12.5318 8.68241 12.5239 7.2887L12.0239 7.29152ZM10.6435 10.6544C9.75302 11.5462 8.54296 12.045 7.28269 12.0398L7.28061 12.5398C8.67434 12.5456 10.0125 11.9939 10.9973 11.0077L10.6435 10.6544Z"
      fill="black"
    />
  </svg>
);

export const NavIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
  >
    <path d="M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z" />
  </svg>
);

export const Filter = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-filter-2-line" clipPath="url(#clip0_1168_4008)">
      <g id="Group">
        <path
          id="Vector"
          d="M11.6673 11.6667V16.6667L8.33398 18.3333V11.6667L3.33398 4.16667V2.5H16.6673V4.16667L11.6673 11.6667ZM5.33732 4.16667L10.0007 11.1617L14.664 4.16667H5.33732Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1168_4008">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Message = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2.15625L9 8.15625L2 2.15625"
      stroke="#121212"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.58333 1H15.25C16.1208 1 16.8333 1.7125 16.8333 2.58333V12.0833C16.8333 12.9542 16.1208 13.6667 15.25 13.6667H2.58333C1.7125 13.6667 1 12.9542 1 12.0833V2.58333C1 1.7125 1.7125 1 2.58333 1Z"
      stroke="#121212"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Widget = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="list 1">
      <path
        id="Vector"
        d="M6.66602 5H17.4993"
        stroke={props.color || "#5A6474"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M6.66602 10H17.4993"
        stroke={props.color || "#5A6474"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M6.66602 15H17.4993"
        stroke={props.color || "#5A6474"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        opacity="0.7"
        d="M2.5 5H2.51"
        stroke={props.color || "#5A6474"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        opacity="0.7"
        d="M2.5 10H2.51"
        stroke={props.color || "#5A6474"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        opacity="0.7"
        d="M2.5 15H2.51"
        stroke={props.color || "#5A6474"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const Notification = () => (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7156 16.8125H3.23438C2.95216 16.8241 2.67043 16.7799 2.40531 16.6825C2.1402 16.5851 1.8969 16.4363 1.68935 16.2447C1.48181 16.0532 1.31409 15.8225 1.1958 15.566C1.07751 15.3095 1.01097 15.0322 1 14.75C1.01674 13.9303 1.27634 13.134 1.74594 12.462C2.52006 11.2315 2.88467 9.78749 2.7875 8.337C2.7875 3.60494 4.9875 1 8.975 1C12.9625 1 15.1625 3.60494 15.1625 8.33906C15.0653 9.78955 15.4299 11.2336 16.2041 12.4641C16.6733 13.1355 16.9329 13.931 16.95 14.75C16.939 15.0322 16.8725 15.3095 16.7542 15.566C16.6359 15.8225 16.4682 16.0532 16.2606 16.2447C16.0531 16.4363 15.8098 16.5851 15.5447 16.6825C15.2796 16.7799 14.9978 16.8241 14.7156 16.8125V16.8125ZM8.975 2.375C5.78156 2.375 4.1625 4.38181 4.1625 8.33906C4.25767 10.0349 3.82745 11.7188 2.9305 13.1612C2.58812 13.622 2.39434 14.1762 2.375 14.75C2.375 15.3158 3.0625 15.4375 3.23438 15.4375H14.7156C14.8861 15.4375 15.575 15.3158 15.575 14.75C15.5558 14.176 15.362 13.6215 15.0195 13.1605C14.1227 11.7183 13.6925 10.0347 13.7875 8.33906C13.7875 4.38181 12.1684 2.375 8.975 2.375Z"
      fill="#121212"
      stroke="#121212"
      strokeWidth="0.5"
    />
    <path
      d="M8.97491 19.9532C8.30936 19.9523 7.67134 19.6875 7.20079 19.2168C6.73024 18.7461 6.46557 18.108 6.46485 17.4425C6.46459 17.2855 6.47979 17.1289 6.51022 16.975C6.52801 16.8865 6.56306 16.8023 6.61336 16.7273C6.66367 16.6523 6.72826 16.588 6.80343 16.538C6.8786 16.488 6.96289 16.4532 7.05148 16.4358C7.14007 16.4184 7.23123 16.4185 7.31975 16.4363C7.40828 16.4541 7.49243 16.4892 7.56741 16.5395C7.64239 16.5898 7.70672 16.6544 7.75674 16.7295C7.80676 16.8047 7.84148 16.889 7.85893 16.9776C7.87637 17.0662 7.8762 17.1573 7.85841 17.2459C7.84561 17.3106 7.83939 17.3765 7.83985 17.4425C7.83454 17.5948 7.85996 17.7466 7.91458 17.8888C7.9692 18.0311 8.05191 18.1609 8.15777 18.2705C8.26363 18.3801 8.39047 18.4673 8.53074 18.5268C8.67102 18.5864 8.82184 18.617 8.97422 18.617C9.12661 18.617 9.27743 18.5864 9.4177 18.5268C9.55797 18.4673 9.68482 18.3801 9.79068 18.2705C9.89654 18.1609 9.97924 18.0311 10.0339 17.8888C10.0885 17.7466 10.1139 17.5948 10.1086 17.4425C10.1091 17.3765 10.1028 17.3106 10.09 17.2459C10.0722 17.1573 10.0721 17.0662 10.0895 16.9776C10.107 16.889 10.1417 16.8047 10.1917 16.7295C10.2417 16.6544 10.3061 16.5898 10.381 16.5395C10.456 16.4892 10.5402 16.4541 10.6287 16.4363C10.7172 16.4185 10.8084 16.4184 10.897 16.4358C10.9856 16.4532 11.0698 16.488 11.145 16.538C11.2202 16.588 11.2848 16.6523 11.3351 16.7273C11.3854 16.8023 11.4204 16.8865 11.4382 16.975C11.4687 17.1289 11.4839 17.2855 11.4836 17.4425C11.4829 18.1078 11.2184 18.7457 10.7481 19.2163C10.2779 19.687 9.64022 19.952 8.97491 19.9532V19.9532Z"
      fill="#121212"
      stroke="#121212"
      strokeWidth="0.5"
    />
  </svg>
);

export const Down = (props: any) => (
  <svg
    width={props.size || "24"}
    height={props.size || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="chevron-down (2) 1">
      <path
        id="Vector"
        d="M6 9L12 15L18 9"
        stroke={props.color || "#121212"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const Faq = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame" clipPath="url(#clip0_1501_4949)">
      <path
        id="Vector"
        d="M9.99935 18.3337C5.39685 18.3337 1.66602 14.6028 1.66602 10.0003C1.66602 5.39783 5.39685 1.66699 9.99935 1.66699C14.6018 1.66699 18.3327 5.39783 18.3327 10.0003C18.3327 14.6028 14.6018 18.3337 9.99935 18.3337ZM9.99935 16.667C11.7675 16.667 13.4632 15.9646 14.7134 14.7144C15.9636 13.4641 16.666 11.7684 16.666 10.0003C16.666 8.23222 15.9636 6.53652 14.7134 5.28628C13.4632 4.03604 11.7675 3.33366 9.99935 3.33366C8.23124 3.33366 6.53555 4.03604 5.2853 5.28628C4.03506 6.53652 3.33268 8.23222 3.33268 10.0003C3.33268 11.7684 4.03506 13.4641 5.2853 14.7144C6.53555 15.9646 8.23124 16.667 9.99935 16.667ZM9.16602 5.83366H10.8327V7.50033H9.16602V5.83366ZM9.16602 9.16699H10.8327V14.167H9.16602V9.16699Z"
        fill={props.color || "#5A6474"}
      />
    </g>
    <defs>
      <clipPath id="clip0_1501_4949">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Share = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-share-line" clipPath="url(#clip0_1168_6648)">
      <g id="Group">
        <path
          id="Vector"
          d="M13.1202 17.0232L8.92121 14.7332C8.373 15.3193 7.66119 15.7269 6.87828 15.9031C6.09537 16.0793 5.27756 16.0159 4.53113 15.7212C3.7847 15.4266 3.14417 14.9142 2.69277 14.2506C2.24138 13.5871 2 12.8032 2 12.0007C2 11.1982 2.24138 10.4143 2.69277 9.75076C3.14417 9.08725 3.7847 8.57486 4.53113 8.28016C5.27756 7.98547 6.09537 7.92211 6.87828 8.09832C7.66119 8.27452 8.373 8.68214 8.92121 9.2682L13.1212 6.9782C12.8828 6.03428 12.9968 5.03579 13.4418 4.16991C13.8869 3.30402 14.6325 2.63018 15.5389 2.2747C16.4452 1.91923 17.4501 1.90651 18.3652 2.23894C19.2803 2.57137 20.0427 3.22612 20.5095 4.08046C20.9764 4.93481 21.1156 5.93009 20.9011 6.87975C20.6866 7.82941 20.1332 8.66824 19.3444 9.23901C18.5557 9.80979 17.5859 10.0733 16.6168 9.9802C15.6477 9.88708 14.7458 9.44371 14.0802 8.7332L9.88021 11.0232C10.0414 11.6646 10.0414 12.3358 9.88021 12.9772L14.0792 15.2672C14.7448 14.5567 15.6467 14.1133 16.6158 14.0202C17.5849 13.9271 18.5547 14.1906 19.3434 14.7614C20.1322 15.3322 20.6856 16.171 20.9001 17.1207C21.1146 18.0703 20.9754 19.0656 20.5085 19.9199C20.0417 20.7743 19.2793 21.429 18.3642 21.7615C17.4491 22.0939 16.4442 22.0812 15.5379 21.7257C14.6315 21.3702 13.8859 20.6964 13.4408 19.8305C12.9958 18.9646 12.8818 17.9661 13.1202 17.0222V17.0232ZM6.00021 14.0002C6.53064 14.0002 7.03935 13.7895 7.41442 13.4144C7.78949 13.0393 8.00021 12.5306 8.00021 12.0002C8.00021 11.4698 7.78949 10.9611 7.41442 10.586C7.03935 10.2109 6.53064 10.0002 6.00021 10.0002C5.46977 10.0002 4.96107 10.2109 4.58599 10.586C4.21092 10.9611 4.00021 11.4698 4.00021 12.0002C4.00021 12.5306 4.21092 13.0393 4.58599 13.4144C4.96107 13.7895 5.46977 14.0002 6.00021 14.0002ZM17.0002 8.0002C17.5306 8.0002 18.0393 7.78949 18.4144 7.41442C18.7895 7.03934 19.0002 6.53064 19.0002 6.0002C19.0002 5.46977 18.7895 4.96106 18.4144 4.58599C18.0393 4.21092 17.5306 4.0002 17.0002 4.0002C16.4698 4.0002 15.9611 4.21092 15.586 4.58599C15.2109 4.96106 15.0002 5.46977 15.0002 6.0002C15.0002 6.53064 15.2109 7.03934 15.586 7.41442C15.9611 7.78949 16.4698 8.0002 17.0002 8.0002ZM17.0002 20.0002C17.5306 20.0002 18.0393 19.7895 18.4144 19.4144C18.7895 19.0393 19.0002 18.5306 19.0002 18.0002C19.0002 17.4698 18.7895 16.9611 18.4144 16.586C18.0393 16.2109 17.5306 16.0002 17.0002 16.0002C16.4698 16.0002 15.9611 16.2109 15.586 16.586C15.2109 16.9611 15.0002 17.4698 15.0002 18.0002C15.0002 18.5306 15.2109 19.0393 15.586 19.4144C15.9611 19.7895 16.4698 20.0002 17.0002 20.0002Z"
          fill="#0A4DFF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1168_6648">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Calendar = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-calendar-line" clipPath="url(#clip0_1168_6652)">
      <g id="Group">
        <path
          id="Vector"
          d="M17 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9V3H15V1H17V3ZM15 5H9V7H7V5H4V9H20V5H17V7H15V5ZM20 11H4V19H20V11Z"
          fill="#0A4DFF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1168_6652">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MailUnread = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-mail-unread-line" clipPath="url(#clip0_1168_6656)">
      <g id="Group">
        <path
          id="Vector"
          d="M16.1 3C15.9659 3.65993 15.9659 4.34007 16.1 5H4.511L12.061 11.662L17.11 7.142C17.536 7.669 18.068 8.108 18.673 8.427L12.072 14.338L4 7.216V19H20V8.9C20.6599 9.03406 21.3401 9.03406 22 8.9V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H16.1ZM21 7C20.606 7 20.2159 6.9224 19.8519 6.77164C19.488 6.62087 19.1573 6.3999 18.8787 6.12132C18.6001 5.84274 18.3791 5.51203 18.2284 5.14805C18.0776 4.78407 18 4.39397 18 4C18 3.60603 18.0776 3.21593 18.2284 2.85195C18.3791 2.48797 18.6001 2.15726 18.8787 1.87868C19.1573 1.6001 19.488 1.37913 19.8519 1.22836C20.2159 1.0776 20.606 1 21 1C21.7956 1 22.5587 1.31607 23.1213 1.87868C23.6839 2.44129 24 3.20435 24 4C24 4.79565 23.6839 5.55871 23.1213 6.12132C22.5587 6.68393 21.7956 7 21 7Z"
          fill="#0A4DFF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1168_6656">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FileAdd = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-file-add-line" clipPath="url(#clip0_1168_6660)">
      <g id="Group">
        <path
          id="Vector"
          d="M15 4H5V20H19V8H15V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16L21 7V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992ZM11 11V8H13V11H16V13H13V16H11V13H8V11H11Z"
          fill="#0A4DFF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1168_6660">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StackShare = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-stackshare-line" clipPath="url(#clip0_1168_6664)">
      <g id="Group">
        <path
          id="Vector"
          d="M9.536 13H7.329C6.917 14.166 5.806 15 4.5 15C2.843 15 1.5 13.657 1.5 12C1.5 10.343 2.843 9 4.5 9C5.806 9 6.918 9.835 7.33 11H9.536L13 5H16.17C16.582 3.835 17.694 3 19 3C20.657 3 22 4.343 22 6C22 7.657 20.657 9 19 9C17.694 9 16.583 8.166 16.171 7H14.154L11.268 11.999L14.155 17H16.171C16.582 15.835 17.694 15 19 15C20.657 15 22 16.343 22 18C22 19.657 20.657 21 19 21C17.694 21 16.583 20.166 16.171 19H13L9.536 13ZM19 17C18.448 17 18 17.448 18 18C18 18.552 18.448 19 19 19C19.552 19 20 18.552 20 18C20 17.448 19.552 17 19 17ZM4.5 11C3.948 11 3.5 11.448 3.5 12C3.5 12.552 3.948 13 4.5 13C5.052 13 5.5 12.552 5.5 12C5.5 11.448 5.052 11 4.5 11ZM19 5C18.448 5 18 5.448 18 6C18 6.552 18.448 7 19 7C19.552 7 20 6.552 20 6C20 5.448 19.552 5 19 5Z"
          fill="#0A4DFF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1168_6664">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Dashboard = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="list 1">
      <g id="Group 2">
        <rect
          id="Rectangle"
          opacity="0.7"
          x="1.605"
          y="2.605"
          width="5.79"
          height="5.74092"
          rx="0.605"
          stroke={props.color || "#5A6474"}
          strokeWidth="1.21"
        />
        <rect
          id="Rectangle Copy 9"
          x="1"
          y="11.9297"
          width="7"
          height="6.95094"
          rx="1.21"
          fill={props.color || "#5A6474"}
        />
        <rect
          id="Rectangle Copy 8"
          x="11"
          y="2"
          width="7"
          height="6.95092"
          rx="1.21"
          fill={props.color || "#5A6474"}
        />
        <rect
          id="Rectangle Copy 10"
          x="11"
          y="11.9297"
          width="7"
          height="6.95094"
          rx="1.21"
          fill={props.color || "#5A6474"}
        />
      </g>
    </g>
  </svg>
);

export const User = (props: any) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-group-2-line" clipPath="url(#clip0_1504_1809)">
      <g id="Group">
        <path
          id="Vector"
          d="M7.56107 9.10384C7.08865 9.10384 6.63558 8.91617 6.30153 8.58212C5.96748 8.24807 5.77982 7.79501 5.77982 7.32259C5.77982 6.85017 5.96748 6.39711 6.30153 6.06306C6.63558 5.72901 7.08865 5.54134 7.56107 5.54134C8.03348 5.54134 8.48655 5.72901 8.8206 6.06306C9.15465 6.39711 9.34232 6.85017 9.34232 7.32259C9.34232 7.79501 9.15465 8.24807 8.8206 8.58212C8.48655 8.91617 8.03348 9.10384 7.56107 9.10384ZM7.91732 15.6335V12.983C7.91732 12.5967 8.03132 12.2412 8.23715 11.9238C7.53151 11.8234 6.81269 11.8713 6.12661 12.0644C5.44054 12.2576 4.80231 12.5918 4.25269 13.0455C5.11804 14.3261 6.42118 15.2467 7.91732 15.6343V15.6335ZM3.52594 11.6055C4.68217 10.7499 6.08309 10.2891 7.52148 10.2913C8.34719 10.2913 9.13886 10.4402 9.87036 10.7125C10.5654 10.441 11.3943 10.2913 12.2715 10.2913C13.5856 10.2913 14.7929 10.627 15.6012 11.2065C15.8685 10.2485 15.9063 9.241 15.7117 8.26564C15.5171 7.29027 15.0955 6.37446 14.481 5.59235C13.8666 4.81025 13.0766 4.18385 12.175 3.76388C11.2735 3.34391 10.2857 3.14218 9.29161 3.17502C8.29757 3.20787 7.32523 3.47437 6.45335 3.95294C5.58146 4.43151 4.83455 5.10869 4.27309 5.92965C3.71163 6.75061 3.35141 7.69226 3.22161 8.67834C3.0918 9.66442 3.19606 10.6672 3.52594 11.6055ZM14.9465 12.7344C14.6354 12.3125 13.5944 11.8747 12.2715 11.8747C10.6834 11.8747 9.50065 12.5056 9.50065 12.983V15.833C10.5994 15.8336 11.6793 15.5482 12.6343 15.005C13.5893 14.4617 14.3856 13.6792 14.9465 12.7344ZM9.50065 17.4163C5.12828 17.4163 1.58398 13.872 1.58398 9.49967C1.58398 5.1273 5.12828 1.58301 9.50065 1.58301C13.873 1.58301 17.4173 5.1273 17.4173 9.49967C17.4173 13.872 13.873 17.4163 9.50065 17.4163ZM12.2715 9.89551C11.8516 9.89551 11.4488 9.72869 11.1519 9.43176C10.855 9.13483 10.6881 8.7321 10.6881 8.31217C10.6881 7.89225 10.855 7.48952 11.1519 7.19259C11.4488 6.89566 11.8516 6.72884 12.2715 6.72884C12.6914 6.72884 13.0941 6.89566 13.3911 7.19259C13.688 7.48952 13.8548 7.89225 13.8548 8.31217C13.8548 8.7321 13.688 9.13483 13.3911 9.43176C13.0941 9.72869 12.6914 9.89551 12.2715 9.89551Z"
          fill={props.color || "#5A6474"}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1504_1809">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Right = (props: any) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="chevron-down (2) 1">
      <path
        id="Vector"
        d="M6.01758 4L10.0101 8L6.01758 12"
        stroke={props.color || "#5A6474"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const Lead = (props: any) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-user-3-line" clipPath="url(#clip0_1504_4937)">
      <g id="Group">
        <path
          id="Vector"
          d="M15.8327 17.417H14.2493V15.8337C14.2493 15.2038 13.9991 14.5997 13.5537 14.1543C13.1083 13.7089 12.5042 13.4587 11.8743 13.4587H7.12435C6.49446 13.4587 5.89037 13.7089 5.44497 14.1543C4.99957 14.5997 4.74935 15.2038 4.74935 15.8337V17.417H3.16602V15.8337C3.16602 14.7838 3.58305 13.777 4.32538 13.0347C5.06772 12.2924 6.07453 11.8753 7.12435 11.8753H11.8743C12.9242 11.8753 13.931 12.2924 14.6733 13.0347C15.4156 13.777 15.8327 14.7838 15.8327 15.8337V17.417ZM9.49935 10.292C8.87557 10.292 8.2579 10.1691 7.6816 9.93042C7.10531 9.69171 6.58167 9.34183 6.14059 8.90075C5.69951 8.45967 5.34963 7.93604 5.11092 7.35974C4.87221 6.78344 4.74935 6.16577 4.74935 5.54199C4.74935 4.91821 4.87221 4.30054 5.11092 3.72425C5.34963 3.14795 5.69951 2.62431 6.14059 2.18323C6.58167 1.74216 7.10531 1.39227 7.6816 1.15356C8.2579 0.914855 8.87557 0.791992 9.49935 0.791992C10.7591 0.791992 11.9673 1.29244 12.8581 2.18323C13.7489 3.07403 14.2493 4.28221 14.2493 5.54199C14.2493 6.80177 13.7489 8.00995 12.8581 8.90075C11.9673 9.79155 10.7591 10.292 9.49935 10.292ZM9.49935 8.70866C10.3392 8.70866 11.1447 8.37503 11.7385 7.78116C12.3324 7.1873 12.666 6.38184 12.666 5.54199C12.666 4.70214 12.3324 3.89669 11.7385 3.30282C11.1447 2.70896 10.3392 2.37533 9.49935 2.37533C8.6595 2.37533 7.85404 2.70896 7.26018 3.30282C6.66631 3.89669 6.33268 4.70214 6.33268 5.54199C6.33268 6.38184 6.66631 7.1873 7.26018 7.78116C7.85404 8.37503 8.6595 8.70866 9.49935 8.70866Z"
          fill={props.color || "#5A6474"}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1504_4937">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Help = (props: any) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="help-circle (2) 1" clipPath="url(#clip0_1496_8045)">
      <path
        id="Vector"
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        stroke={props.color || "#5A6474"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        opacity="0.7"
        d="M6.81836 6.75043C6.99469 6.24918 7.34272 5.82651 7.80083 5.55728C8.25893 5.28805 8.79753 5.18963 9.32124 5.27946C9.84495 5.36929 10.32 5.64157 10.6622 6.04807C11.0044 6.45458 11.1916 6.96907 11.1909 7.50043C11.1909 9.00043 8.94086 9.75043 8.94086 9.75043"
        stroke={props.color || "#5A6474"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        opacity="0.7"
        d="M9 12.75H9.00833"
        stroke={props.color || "#5A6474"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1496_8045">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Settings = (props: any) => (
  <svg
    {...props}
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-settings-3-line" clipPath="url(#clip0_1501_4940)">
      <g id="Group">
        <path
          id="Vector"
          d="M2.64339 13.4584C2.30873 12.8797 2.04858 12.261 1.86914 11.617C2.25968 11.4184 2.58765 11.1156 2.81679 10.7421C3.04592 10.3687 3.16729 9.93913 3.16745 9.50099C3.16762 9.06284 3.04657 8.63319 2.81772 8.25956C2.58886 7.88594 2.26111 7.5829 1.87072 7.38398C2.22859 6.08999 2.90997 4.9084 3.85068 3.95052C4.21809 4.18939 4.64442 4.32194 5.0825 4.33351C5.52057 4.34509 5.95331 4.23523 6.33282 4.0161C6.71233 3.79696 7.0238 3.4771 7.23278 3.09191C7.44176 2.70672 7.54009 2.27122 7.51689 1.8336C8.81689 1.49764 10.181 1.49818 11.4808 1.83519C11.4578 2.27279 11.5563 2.70823 11.7654 3.09331C11.9746 3.47839 12.2862 3.7981 12.6658 4.01707C13.0453 4.23603 13.4781 4.34571 13.9161 4.33397C14.3542 4.32222 14.7805 4.18951 15.1478 3.95052C15.6061 4.4176 16.0131 4.94881 16.3551 5.54177C16.6978 6.13473 16.9543 6.75302 17.1293 7.38319C16.7388 7.58182 16.4108 7.88461 16.1817 8.25806C15.9525 8.63152 15.8312 9.06108 15.831 9.49922C15.8308 9.93737 15.9519 10.367 16.1807 10.7406C16.4096 11.1143 16.7373 11.4173 17.1277 11.6162C16.7699 12.9102 16.0885 14.0918 15.1478 15.0497C14.7804 14.8108 14.354 14.6783 13.9159 14.6667C13.4779 14.6551 13.0451 14.765 12.6656 14.9841C12.2861 15.2032 11.9746 15.5231 11.7657 15.9083C11.5567 16.2935 11.4584 16.729 11.4816 17.1666C10.1816 17.5026 8.81742 17.502 7.51768 17.165C7.54068 16.7274 7.44215 16.292 7.23301 15.9069C7.02388 15.5218 6.71227 15.2021 6.33269 14.9831C5.95311 14.7642 5.52035 14.6545 5.0823 14.6662C4.64425 14.678 4.21798 14.8107 3.85068 15.0497C3.3828 14.5723 2.97715 14.0376 2.64339 13.4584ZM7.12422 13.6136C7.96784 14.1002 8.60214 14.8811 8.90547 15.8065C9.30051 15.8437 9.69714 15.8445 10.0922 15.8073C10.3957 14.8817 11.0303 14.1008 11.8742 13.6144C12.7175 13.1265 13.7113 12.9672 14.6648 13.1671C14.8944 12.8441 15.0923 12.4997 15.257 12.1395C14.6074 11.4139 14.2485 10.474 14.2492 9.5001C14.2492 8.5026 14.6213 7.57081 15.257 6.86069C15.0912 6.5006 14.8924 6.15661 14.6633 5.8331C13.7103 6.03285 12.7172 5.87386 11.8742 5.3866C11.0306 4.90002 10.3963 4.11913 10.093 3.19369C9.69793 3.15648 9.30131 3.15569 8.90626 3.1929C8.60274 4.11847 7.96814 4.89938 7.12422 5.38581C6.28093 5.87373 5.28714 6.03302 4.3336 5.8331C4.10446 6.15633 3.9062 6.50037 3.74143 6.86069C4.39105 7.5863 4.74992 8.52619 4.74922 9.5001C4.74922 10.4976 4.37714 11.4294 3.74143 12.1395C3.90726 12.4996 4.10603 12.8436 4.33518 13.1671C5.28812 12.9674 6.28126 13.1264 7.12422 13.6136ZM9.49922 11.8751C8.86933 11.8751 8.26524 11.6249 7.81984 11.1795C7.37445 10.7341 7.12422 10.13 7.12422 9.5001C7.12422 8.87022 7.37445 8.26612 7.81984 7.82073C8.26524 7.37533 8.86933 7.1251 9.49922 7.1251C10.1291 7.1251 10.7332 7.37533 11.1786 7.82073C11.624 8.26612 11.8742 8.87022 11.8742 9.5001C11.8742 10.13 11.624 10.7341 11.1786 11.1795C10.7332 11.6249 10.1291 11.8751 9.49922 11.8751ZM9.49922 10.2918C9.70919 10.2918 9.91055 10.2084 10.059 10.0599C10.2075 9.91143 10.2909 9.71007 10.2909 9.5001C10.2909 9.29014 10.2075 9.08878 10.059 8.94031C9.91055 8.79185 9.70919 8.70844 9.49922 8.70844C9.28926 8.70844 9.0879 8.79185 8.93943 8.94031C8.79096 9.08878 8.70756 9.29014 8.70756 9.5001C8.70756 9.71007 8.79096 9.91143 8.93943 10.0599C9.0879 10.2084 9.28926 10.2918 9.49922 10.2918Z"
          fill={props.color || "#5A6474"}
        />
      </g>
      <circle
        id="Ellipse 207"
        cx="9.5"
        cy="9.5"
        r="2.5"
        fill={props.color || "#8B929E"}
      />
    </g>
    <defs>
      <clipPath id="clip0_1501_4940">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const More = () => (
  <svg
    width="5"
    height="21"
    viewBox="0 0 5 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2.5" cy="2.5" r="2.5" fill="#D9D9D9" />
    <circle cx="2.5" cy="10.5" r="2.5" fill="#D9D9D9" />
    <circle cx="2.5" cy="18.5" r="2.5" fill="#D9D9D9" />
  </svg>
);
